<template>
    <div class="panel panel-danger">
        <div class="panel-heading">
            <span class="fa-stack">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-exclamation fa-stack-1x fa-inverse"></i>
            </span>
            <b>Détails</b>
        </div>
        <div class="panel-body">
            <ul>
                <li>Le formulaire rencontre une erreur technique.</li>
                <li>Vous pouvez réessayer plus tard ou <a href="https://www.ge.ch/inscription-aux-e-demarches/besoin-aide"
                                                          title="Formulaire d'assistance et support téléphonique">contacter l'assistance
                                                       </a>.
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: 'error',
};
</script>

<style scoped>

</style>
